import type { TFunction } from "i18next";

/**
 * Legge dai file di traduzione una LISTA (voci di un carosello, statistiche…)
 * invece di una singola stringa.
 *
 * Serve un guardiano perché i18next, quando una chiave manca, restituisce la
 * chiave stessa come stringa: senza controllo il sito mostrerebbe all'utente
 * "home.marquee.items" al posto del contenuto. Qui una traduzione mancante o
 * malformata produce una lista vuota, e chi la usa decide come comportarsi
 * (il ticker, ad esempio, semplicemente non si disegna).
 */
export function translatedList<T>(t: TFunction, key: string): T[] {
  let value: unknown;
  try {
    value = t(key, { returnObjects: true });
  } catch {
    return [];
  }
  if (!Array.isArray(value)) return []; // chiave mancante → i18next torna la stringa della chiave
  return value as T[];
}

/** Una statistica della homepage: il numero è animato, il suffisso lo segue. */
export interface StatItem {
  value: number;
  suffix: string;
  label: string;
}
